import 'globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {

            // turn dots into numbers
            var slickSlider = $('.slider__items').slick({
                customPaging: function (slider, i) {
                    const number = (i + 1);
                    const slideNumber = (number.toString().length < 2) ? '0' + number : number;
                    return '<span class="dot">' + slideNumber + '</span><span data-slick-index="' + i + '" class="progressBar"></span>';
                }
            });
            if (document.querySelector('.avency-neos-baseslider-content-slider') !== null) {
                // position dots and arrows under the image
                window.onresize = function () {
                    setProgressbar();
                };

                // progressbar
                var percentTime;
                var tick;
                var progressBarIndex = 0;
                var autoplaySpeed = slickSlider[0].slick.options.autoplaySpeed;
                var speed = (autoplaySpeed / 1000);

                $('.slick-dots .progressBar').each(function (index) {
                    var progress = "<div class='inProgress inProgress" + index + "'></div>";
                    $(this).html(progress);
                });

                function setProgressbar() {
                    var dots = document.querySelector('.avency-neos-baseslider-content-slider .slick-dots');
                    if (dots) {
                        var dotsContainer = document.createElement("div");
                        dotsContainer.setAttribute('class', 'container');
                        dotsContainer.innerHTML = dots.innerHTML;
                        dots.innerHTML = '';
                        dots.appendChild(dotsContainer);
                    }
                }

                function startProgressbar() {
                    if (document.querySelector('.neos-backend') == null) {
                        resetProgressbar();
                        percentTime = 0;
                        tick = setInterval(interval, 10);
                    }
                }

                function interval() {
                    if (($('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
                        progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
                        startProgressbar();
                    } else {
                        percentTime += 1 / (speed);
                        $('.inProgress' + progressBarIndex).css({
                            width: percentTime + "%"
                        });
                        $('.inProgress' + progressBarIndex).parent('.progressBar').css({
                            display: 'inline-block'
                        });
                        if (percentTime >= 100) {
                            $('.slider__items').slick('slickNext');
                            progressBarIndex++;
                            if (progressBarIndex > 1) {
                                progressBarIndex = 0;
                            }
                            startProgressbar();
                        }
                    }
                }

                function resetProgressbar() {
                    $('.inProgress').css({
                        width: 0 + '%'
                    });
                    $('.inProgress').parent('.progressBar').css({
                        display: 'none'
                    });
                    clearInterval(tick);
                }

                setProgressbar();
                startProgressbar();

                $('.slick-dots li').click(function () {
                    clearInterval(tick);
                    var goToThisIndex = $(this).find('.progressBar').data('slickIndex');
                    $('.slider__items').slick('slickGoTo', goToThisIndex, false);
                    startProgressbar();
                });
            }
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
